import { NgModule } from '@angular/core';
import { GetCountryNameByCodePipe } from './get-country-name-by-code.pipe';

@NgModule({
  declarations: [GetCountryNameByCodePipe],
  exports: [GetCountryNameByCodePipe],
})
export class GetCountryNameByCodeModule {}
